import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import GlobalAppContext from './GlobalContext';
import { IUser } from '../models/interfaces/user.interface';

const ContextWrapper = ({ children }: React.PropsWithChildren<unknown>) => {
  const [user, setUser] = useState<IUser>({
    id: 0,
    countryId: 0,
    roleId: 0,
    name: '',
    email: '',
    dateOfBirth: '',
    isActive: false,
    isBackOffice: false
  });
  const [token, setToken] = useState<string>('');
  const [isUserSignedIn, setIsUserSignedIn] = useState<boolean>(false);
  const [monthIndex, setMonthIndex] = useState(dayjs().month());
  const [showEventModal, setShowEventModal] = useState(false);

  useEffect(() => {
    if (!isUserSignedIn) {
      setIsUserSignedIn(false);
    }
  }, [isUserSignedIn]);

  return (
    <GlobalAppContext.Provider
      value={{
        user,
        setUser,
        token,
        setToken,
        isUserSignedIn,
        setIsUserSignedIn,
        monthIndex,
        setMonthIndex,
        showEventModal,
        setShowEventModal
      }}>
      {children}
    </GlobalAppContext.Provider>
  );
};

export default ContextWrapper;
